import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { AlertTriangle, WifiOff, Settings } from "lucide-react";

export default function AdminSupport() {
  const [attention, setAttention] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchAttention();
  }, []);

  const fetchAttention = async () => {
    try {
      const res = await api.get("/admin/dashboard/attention");
      setAttention(res.data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-96">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-emerald-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-zinc-400">Carregando...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-white">🚨 Suporte</h1>
        <p className="text-zinc-400 mt-1">Clientes que precisam de atenção</p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {/* WhatsApp Disconnected */}
        <div className="bg-zinc-900 border border-red-500/20 rounded-xl p-6">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-12 h-12 rounded-lg bg-red-500/10 flex items-center justify-center">
              <WifiOff className="w-6 h-6 text-red-500" />
            </div>
            <div>
              <h3 className="text-lg font-semibold text-white">WhatsApp Desconectado</h3>
              <p className="text-sm text-zinc-400">{attention?.whatsapp_disconnected?.length || 0} clientes</p>
            </div>
          </div>
          <div className="space-y-2">
            {attention?.whatsapp_disconnected?.map((item) => (
              <Link
                key={item.id}
                to={`/admin/clients/${item.id}`}
                className="block p-4 bg-zinc-800 rounded-lg hover:bg-zinc-700 transition-colors"
              >
                <p className="text-sm font-medium text-white">{item.user?.name || "Sem nome"}</p>
                <p className="text-xs text-zinc-400 mt-1">{item.user?.email}</p>
                <p className="text-xs text-red-400 mt-1">Status: {item.evolution_status}</p>
              </Link>
            ))}
          </div>
        </div>

        {/* Integration Errors */}
        <div className="bg-zinc-900 border border-yellow-500/20 rounded-xl p-6">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-12 h-12 rounded-lg bg-yellow-500/10 flex items-center justify-center">
              <AlertTriangle className="w-6 h-6 text-yellow-500" />
            </div>
            <div>
              <h3 className="text-lg font-semibold text-white">Erros de Integração</h3>
              <p className="text-sm text-zinc-400">{attention?.integration_errors?.length || 0} clientes</p>
            </div>
          </div>
          <div className="space-y-2">
            {attention?.integration_errors?.map((item) => (
              <Link
                key={item.id}
                to={`/admin/clients/${item.id}`}
                className="block p-4 bg-zinc-800 rounded-lg hover:bg-zinc-700 transition-colors"
              >
                <p className="text-sm font-medium text-white">{item.user?.name || "Sem nome"}</p>
                <p className="text-xs text-zinc-400 mt-1">{item.user?.email}</p>
                <p className="text-xs text-yellow-400 mt-1">Verificar logs de integração</p>
              </Link>
            ))}
          </div>
        </div>

        {/* Unconfigured */}
        <div className="bg-zinc-900 border border-zinc-700 rounded-xl p-6">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-12 h-12 rounded-lg bg-zinc-700 flex items-center justify-center">
              <Settings className="w-6 h-6 text-zinc-400" />
            </div>
            <div>
              <h3 className="text-lg font-semibold text-white">Sem Configuração</h3>
              <p className="text-sm text-zinc-400">{attention?.unconfigured?.length || 0} clientes</p>
            </div>
          </div>
          <div className="space-y-2">
            {attention?.unconfigured?.map((item) => (
              <Link
                key={item.id}
                to={`/admin/clients/${item.id}`}
                className="block p-4 bg-zinc-800 rounded-lg hover:bg-zinc-700 transition-colors"
              >
                <p className="text-sm font-medium text-white">{item.user?.name || "Sem nome"}</p>
                <p className="text-xs text-zinc-400 mt-1">{item.user?.email}</p>
                <p className="text-xs text-zinc-500 mt-1">
                  Cadastro: {new Date(item.created_at).toLocaleDateString("pt-BR")}
                </p>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
